import { render, staticRenderFns } from "./ContractType.vue?vue&type=template&id=36124151&scoped=true&"
import script from "./ContractType.vue?vue&type=script&lang=js&"
export * from "./ContractType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36124151",
  null
  
)

export default component.exports